var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// @ts-ignore
import enTranslations from "ckeditor5/translations/en.js";
// @ts-ignore
import esTranslations from "ckeditor5/translations/es.js";
// @ts-ignore
import enPremiumFeaturesTranslations from "ckeditor5-premium-features/translations/en.js";
// @ts-ignore
import esPremiumFeaturesTranslations from "ckeditor5-premium-features/translations/es.js";
import { AccessibilityHelp, Alignment, Autoformat, AutoImage, AutoLink, Autosave, BalloonToolbar, BlockQuote, Bold, CloudServices, Code, CodeBlock, Essentials, FindAndReplace, FontBackgroundColor, FontColor, FontFamily, FontSize, Heading, Highlight, HorizontalLine, ImageBlock, ImageCaption, ImageInline, ImageResize, ImageStyle, ImageTextAlternative, ImageToolbar, ImageUpload, Indent, IndentBlock, Italic, List, ListProperties, Mention, Minimap, PageBreak, Paragraph, Plugin, RemoveFormat, SelectAll, ShowBlocks, SpecialCharacters, SpecialCharactersArrows, SpecialCharactersCurrency, SpecialCharactersEssentials, SpecialCharactersLatin, SpecialCharactersMathematical, SpecialCharactersText, Strikethrough, Subscript, Superscript, Table, TableCaption, TableCellProperties, TableColumnResize, TableProperties, TableToolbar, TextTransformation, TodoList, Underline, Undo, } from "ckeditor5";
import { ImportWord, MergeFields, Pagination, } from "ckeditor5-premium-features";
import "./certificates.css";
var translationsMap = {
    en: enTranslations,
    es: esTranslations,
};
var premiumFeaturesTranslationsMap = {
    en: enPremiumFeaturesTranslations,
    es: esPremiumFeaturesTranslations,
};
var CustomUploadAdapter = /** @class */ (function () {
    function CustomUploadAdapter(loader) {
        this.maxFileSize = 300 * 1024; // 300 KB en bytes
        this.loader = loader;
    }
    CustomUploadAdapter.prototype.resizeImage = function (file) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            var reader = new FileReader();
            reader.onload = function () {
                img.src = reader.result;
            };
            img.onload = function () {
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                if (!ctx) {
                    reject(new Error("No se pudo obtener el contexto del lienzo"));
                    return;
                }
                var maxWidth = 800;
                var maxHeight = 800;
                var width = img.width;
                var height = img.height;
                var newWidth = width;
                var newHeight = height;
                if (width > height) {
                    if (width > maxWidth) {
                        newWidth = maxWidth;
                        newHeight = (height * maxWidth) / width;
                    }
                }
                else {
                    if (height > maxHeight) {
                        newHeight = maxHeight;
                        newWidth = (width * maxHeight) / height;
                    }
                }
                canvas.width = newWidth;
                canvas.height = newHeight;
                ctx.drawImage(img, 0, 0, newWidth, newHeight);
                canvas.toBlob(function (blob) {
                    if (blob) {
                        resolve(new File([blob], file.name, { type: file.type }));
                    }
                    else {
                        reject(new Error("No se pudo redimensionar la imagen"));
                    }
                }, file.type, 0.7);
            };
            img.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    CustomUploadAdapter.prototype.upload = function () {
        var _this = this;
        return this.loader.file
            .then(function (file) {
            if (file.size > _this.maxFileSize) {
                return _this.resizeImage(file).then(function (resizedFile) {
                    return _this.convertToBase64(resizedFile);
                });
            }
            return _this.convertToBase64(file);
        })
            .catch(function (error) {
            console.error("Error al manejar la imagen:", error);
            throw error;
        });
    };
    CustomUploadAdapter.prototype.convertToBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onloadend = function () {
                resolve({
                    default: reader.result,
                });
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    CustomUploadAdapter.prototype.abort = function () {
        console.log("Subida abortada");
    };
    return CustomUploadAdapter;
}());
var CustomUploadAdapterPlugin = /** @class */ (function (_super) {
    __extends(CustomUploadAdapterPlugin, _super);
    function CustomUploadAdapterPlugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomUploadAdapterPlugin.prototype.init = function () {
        var editor = this.editor;
        // Integra el CustomUploadAdapter en el sistema de subida de CKEditor
        editor.plugins.get("FileRepository").createUploadAdapter = function (loader) {
            return new CustomUploadAdapter(loader);
        };
    };
    return CustomUploadAdapterPlugin;
}(Plugin));
export var editorCustom = function (configOverrides) {
    var selectedLanguage = configOverrides.language || "en";
    return {
        toolbar: {
            items: [
                "previousPage",
                "nextPage",
                "|",
                "undo",
                "redo",
                "|",
                "showBlocks",
                "|",
                "insertMergeField",
                "|",
                "heading",
                "|",
                "fontSize",
                "fontFamily",
                "fontColor",
                "fontBackgroundColor",
                "|",
                "bold",
                "italic",
                "underline",
                "|",
                // "link",
                "insertImage",
                "insertTable",
                "highlight",
                "blockQuote",
                "codeBlock",
                "|",
                "alignment",
                "|",
                "bulletedList",
                "numberedList",
                "todoList",
                "outdent",
                "indent",
            ],
            shouldNotGroupWhenFull: true,
        },
        plugins: [
            AccessibilityHelp,
            Alignment,
            Autoformat,
            AutoImage,
            AutoLink,
            Autosave,
            BalloonToolbar,
            BlockQuote,
            Bold,
            CloudServices,
            Code,
            CodeBlock,
            Essentials,
            FindAndReplace,
            FontBackgroundColor,
            FontColor,
            FontFamily,
            FontSize,
            Heading,
            Highlight,
            HorizontalLine,
            ImageBlock,
            ImageCaption,
            ImageInline,
            ImageResize,
            ImageStyle,
            ImageTextAlternative,
            ImageToolbar,
            ImageUpload,
            ImportWord,
            Indent,
            IndentBlock,
            Italic,
            List,
            ListProperties,
            Mention,
            MergeFields,
            Minimap,
            Pagination,
            PageBreak,
            Paragraph,
            RemoveFormat,
            ShowBlocks,
            SelectAll,
            SpecialCharacters,
            SpecialCharactersArrows,
            SpecialCharactersCurrency,
            SpecialCharactersEssentials,
            SpecialCharactersLatin,
            SpecialCharactersMathematical,
            SpecialCharactersText,
            Strikethrough,
            Subscript,
            Superscript,
            Table,
            TableCaption,
            TableCellProperties,
            TableColumnResize,
            TableProperties,
            TableToolbar,
            TextTransformation,
            TodoList,
            Underline,
            Undo,
            CustomUploadAdapterPlugin,
        ],
        balloonToolbar: [
            "bold",
            "italic",
            "outdent",
            "indent",
            "|",
            "insertImage",
            "|",
            "bulletedList",
            "numberedList",
        ],
        fontFamily: {
            supportAllValues: true,
        },
        fontSize: {
            options: [10, 12, 14, "default", 18, 20, 22],
            supportAllValues: true,
        },
        heading: {
            options: [
                {
                    model: "paragraph",
                    title: "Paragraph",
                    class: "ck-heading_paragraph",
                },
                {
                    model: "heading1",
                    view: "h1",
                    title: "Heading 1",
                    class: "ck-heading_heading1",
                },
                {
                    model: "heading2",
                    view: "h2",
                    title: "Heading 2",
                    class: "ck-heading_heading2",
                },
                {
                    model: "heading3",
                    view: "h3",
                    title: "Heading 3",
                    class: "ck-heading_heading3",
                },
                {
                    model: "heading4",
                    view: "h4",
                    title: "Heading 4",
                    class: "ck-heading_heading4",
                },
                {
                    model: "heading5",
                    view: "h5",
                    title: "Heading 5",
                    class: "ck-heading_heading5",
                },
                {
                    model: "heading6",
                    view: "h6",
                    title: "Heading 6",
                    class: "ck-heading_heading6",
                },
            ],
        },
        image: {
            toolbar: [
                "toggleImageCaption",
                "imageTextAlternative",
                "|",
                "imageStyle:inline",
                "imageStyle:wrapText",
                "imageStyle:breakText",
                "|",
                "resizeImage",
            ],
        },
        language: selectedLanguage,
        licenseKey: configOverrides === null || configOverrides === void 0 ? void 0 : configOverrides.licenseKey,
        list: {
            properties: {
                styles: true,
                startIndex: true,
                reversed: true,
            },
        },
        menuBar: {
            isVisible: true,
        },
        mergeFields: configOverrides === null || configOverrides === void 0 ? void 0 : configOverrides.mergeFields,
        allowedContent: true,
        minimap: {
            container: configOverrides === null || configOverrides === void 0 ? void 0 : configOverrides.container,
            extraClasses: "editor-container_include-minimap ck-minimap__iframe-content",
        },
        pagination: {
            pageWidth: "215.9mm",
            pageHeight: "279.4mm",
            displayHeaderFooter: false,
            pageMargins: {
                top: "1.5mm",
                bottom: "1.5mm",
                right: "1.5mm",
                left: "1.5mm",
            },
        },
        placeholder: configOverrides.placeholder,
        table: {
            contentToolbar: [
                "tableColumn",
                "tableRow",
                "mergeTableCells",
                "tableProperties",
                "tableCellProperties",
            ],
        },
        translations: [
            translationsMap[selectedLanguage] || translationsMap["en"],
            premiumFeaturesTranslationsMap[selectedLanguage] ||
                premiumFeaturesTranslationsMap["en"],
        ],
        upload: {
            types: ["jpg", "jpeg", "png", "gif"],
        },
    };
};
